import { render, staticRenderFns } from "./homeDownload.vue?vue&type=template&id=2b194f72&scoped=true&"
import script from "./homeDownload.vue?vue&type=script&lang=ts&"
export * from "./homeDownload.vue?vue&type=script&lang=ts&"
import style0 from "./homeDownload.vue?vue&type=style&index=0&id=2b194f72&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b194f72",
  null
  
)

export default component.exports